var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profile-aside" }, [
    _c("span", { staticClass: "profile-aside__title" }, [
      _vm._v("Стать нашим оптовиком"),
    ]),
    _c("span", { staticClass: "profile-aside__description" }, [
      _vm._v(
        "\n    Получить специальные цены и предложения на весь каталог гаджетов\n  "
      ),
    ]),
    _c(
      "button",
      { staticClass: "btn btn--md btn--black", on: { click: _vm.openModal } },
      [_c("span", [_vm._v("Стать партнером")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }